import { render, staticRenderFns } from "./SaveComponentDialog.vue?vue&type=template&id=a4cfcfb6&scoped=true&"
import script from "./SaveComponentDialog.vue?vue&type=script&lang=js&"
export * from "./SaveComponentDialog.vue?vue&type=script&lang=js&"
import style0 from "./SaveComponentDialog.vue?vue&type=style&index=0&id=a4cfcfb6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cfcfb6",
  null
  
)

export default component.exports